import React from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";

function Services() {
    const services = [
        {
            title: "Franchisee support",
            description:
                "We’ve got your back with dedicated support for franchise locations, handling order calls, and streamlining communication so you can focus on growing your brand. Consider us your behind-the-scenes partner in keeping every location running smoothly!",
            image: "",
        },
        {
            title: "Order Taking",
            description:
                "Easily handle online orders using our efficient platform. Get instant updates, and monitor sales trends. Improve efficiency and customer satisfaction through our ordering service.",
            image: "",
        },
        {
            title: "Back office support",
            description:
                "Streamline operations with our comprehensive back-office support, managing inventory, and enhancing efficiency to prioritize growth and improve customer satisfaction.",
            image: "",
        },

    ];
    return (
        <div>
            <div className="sub-banner-section-outer">
                <Navigation/>
                <section className="sub-banner-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="sub-banner-text">
                                    <h1 className="mb-lg-4 mb-3 text-white">Services</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <section class="services-section position-relative">
                <div class="container">
                    <div class="row">
                        <div class="services-section-inner text-center position-relative col-12">
                            <h2 class="mb-lg-4 mb-md-3 mb-2">Services We Offer</h2>
                            <figure class="services-section-shape-img-1 mb-0 position-absolute">
                                <img
                                    class="img-fluid"
                                    src="assets/images/services-section-shape-img-1.png"
                                />
                            </figure>
                        </div>
                    </div>
                    <div class="row">
                        {services.map((data, index) => (
                            <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center">
                                <div class="services-section-plan-box hover-effect">
                                    {/* <figure>
                    <img
                      src="assets/images/services-section-plan-box-img-1.png"
                      alt=""
                    />
                  </figure> */}
                                    <h4 class="font-weight-bold text-dark">{data.title}</h4>
                                    <p class="text-size-16">{data.description}</p>
                                </div>
                            </div>
                        ))}

                        {/* <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center">
              <div class="services-section-plan-box hover-effect">
                <figure>
                  <img
                    src="assets/images/services-section-plan-box-img-2.png"
                    alt=""
                  />
                </figure>
                <h4 class="font-weight-bold">Debt Collection</h4>
                <p class="text-size-16">
                  Lorem ipsum dolor sit amet consectet uradipisc ing elit sed do
                  eiusm temp orinc ididuquis enimone.
                </p>
                <a class="d-inline-block text-decoration-none" href="#">
                  Read More
                  <i class="far fa-long-arrow-alt-right position-relative"></i>
                </a>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 text-md-left text-center">
              <div class="services-section-plan-box hover-effect">
                <figure>
                  <img
                    src="assets/images/services-section-plan-box-img-3.png"
                    alt=""
                  />
                </figure>
                <h4 class="font-weight-bold">Inbound Requests</h4>
                <p class="text-size-16">
                  Lorem ipsum dolor sit amet consectet uradipisc ing elit sed do
                  eiusm temp orinc ididuquis enimone.
                </p>
                <a class="d-inline-block text-decoration-none" href="#">
                  Read More
                  <i class="far fa-long-arrow-alt-right position-relative"></i>
                </a>
              </div>
            </div> */}
                    </div>
                    <div class="divider"></div>
                    {/* <div class="row position-relative">
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center">
              <div class="services-section-plan-box hover-effect">
                <figure>
                  <img
                    src="assets/images/services-section-plan-box-img-4.png"
                    alt=""
                  />
                </figure>
                <h4 class="font-weight-bold">Customer Support</h4>
                <p class="text-size-16">
                  Lorem ipsum dolor sit amet consectet uradipisc ing elit sed do
                  eiusm temp orinc ididuquis enimone.
                </p>
                <a class="d-inline-block text-decoration-none" href="#">
                  Read More
                  <i class="far fa-long-arrow-alt-right position-relative"></i>
                </a>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4 text-md-left text-center">
              <div class="services-section-plan-box hover-effect">
                <figure>
                  <img
                    src="assets/images/services-section-plan-box-img-5.png"
                    alt=""
                  />
                </figure>
                <h4 class="font-weight-bold">Virtual Assistance</h4>
                <p class="text-size-16">
                  Lorem ipsum dolor sit amet consectet uradipisc ing elit sed do
                  eiusm temp orinc ididuquis enimone.
                </p>
                <a class="d-inline-block text-decoration-none" href="#">
                  Read More
                  <i class="far fa-long-arrow-alt-right position-relative"></i>
                </a>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12 text-md-left text-center">
              <div class="services-section-plan-box hover-effect">
                <figure>
                  <img
                    src="assets/images/services-section-plan-box-img-6.png"
                    alt=""
                  />
                </figure>
                <h4 class="font-weight-bold">Live Chat Support</h4>
                <p class="text-size-16">
                  Lorem ipsum dolor sit amet consectet uradipisc ing elit sed do
                  eiusm temp orinc ididuquis enimone.
                </p>
                <a class="d-inline-block text-decoration-none" href="#">
                  Read More
                  <i class="far fa-long-arrow-alt-right position-relative"></i>
                </a>
              </div>
            </div>
          </div> */}
                </div>
            </section>
            <Footer/>
        </div>
    );
}

export default Services;
